import React, { useEffect, useState } from 'react';
import { fetchSchoolData, getPhone1, getEmail1 } from '../Schoolinfo.js';

// Icons
import { FaPhoneAlt, FaEnvelope, FaAddressBook, FaExternalLinkAlt } from 'react-icons/fa';

const ContactDiv = () => {
  const [contactInfo, setContactInfo] = useState({
    phone: '',
    email: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await fetchSchoolData();
        setContactInfo({
          phone: getPhone1(),
          email: getEmail1()
        });
      } catch (error) {
        console.error('Error fetching school data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePhoneClick = () => {
    if (contactInfo.phone) {
      window.location.href = `tel:${contactInfo.phone.replace(/\D/g, '')}`;
    }
  };

  const handleEmailClick = () => {
    if (contactInfo.email) {
      window.location.href = `mailto:${contactInfo.email}`;
    }
  };

  return (
    <div className="max-w-full mx-auto my-4 bg-white rounded-xl shadow-lg overflow-hidden">
      {/* Header Bar */}
      <div className="bg-blue-500 px-4 py-3 flex items-center">
        <FaAddressBook className="text-white text-lg mr-2" />
        <h2 className="text-lg font-bold text-white">Contact Information</h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center p-6">
          <div className="animate-pulse h-12 w-12 rounded-full bg-blue-100"></div>
        </div>
      ) : (
        <div className="p-4 space-y-4">
          {/* Phone - Mobile app style button */}
          <div 
            className="flex items-center p-3 bg-blue-50 rounded-lg active:bg-blue-100 cursor-pointer transition-colors duration-200"
            onClick={handlePhoneClick}
          >
            <div className="bg-blue-500 rounded-full p-2 mr-3">
              <FaPhoneAlt className="text-white text-lg" />
            </div>
            <div className="flex-grow">
              <p className="text-sm text-gray-500">Phone</p>
              <p className="font-medium">{contactInfo.phone || 'Not available'}</p>
            </div>
            <FaExternalLinkAlt className="text-blue-400 text-sm" />
          </div>

          {/* Email - Mobile app style button */}
          <div 
            className="flex items-center p-3 bg-blue-50 rounded-lg active:bg-blue-100 cursor-pointer transition-colors duration-200"
            onClick={handleEmailClick}
          >
            <div className="bg-blue-500 rounded-full p-2 mr-3">
              <FaEnvelope className="text-white text-lg" />
            </div>
            <div className="flex-grow">
              <p className="text-sm text-gray-500">Email</p>
              <p className="font-medium">{contactInfo.email || 'Not available'}</p>
            </div>
            <FaExternalLinkAlt className="text-blue-400 text-sm" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactDiv;